import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { connect } from 'react-redux';
import { setBreadcrumbItems } from "../../store/actions";
import { jwtDecode } from "jwt-decode";
import {
  Button, Modal, ModalHeader, ModalBody, ModalFooter,
  Form, Input, Label, Row, Col
} from 'reactstrap';


const API = process.env.REACT_APP_API;


const ListadoUser = (props) => {
  document.title = "Usuarios | Listado - Ges Sindical";

  const breadcrumbItems = [
    { title: "Usuarios", link: "#" },
    { title: "Listado", link: "#" },
  ];

  const [usuarios, setUsuarios] = useState([]);
  const [organismos, setOrganismos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    apellido: '',
    correo: '',
    pass: '',
    rol: 'usuario',
    organismosPermitidos: [],
  });

  const token = localStorage.getItem("token");
  const decoded = jwtDecode(token);
  const userRol = decoded.rol;
  const userOrganismos = decoded.organismosPermitidos || [];
  const idOrganismoActual = "67dc3c401333062c757316ef"; // Atlético Minero

  useEffect(() => {
    props.setBreadcrumbItems('Listado Usuarios', breadcrumbItems);
    obtenerUsuarios();
    obtenerOrganismos();
  }, []);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
    setFormData({
      nombre: '',
      apellido: '',
      correo: '',
      pass: '',
      rol: 'usuario',
      organismosPermitidos: [],
    });
  };

  const obtenerUsuarios = async () => {
    try {
      const res = await fetch(`${API}/usuarios`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const data = await res.json();
      if (res.ok) {
        let filtrados = [];

        if (userRol === "Dios") {
          filtrados = data;
        } else if (userRol === "admin") {
          filtrados = data.filter(user =>
            user.rol !== "Dios" &&
            user.organismosPermitidos?.some(org => org._id === idOrganismoActual)
          );
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Acceso restringido',
            text: 'No tienes permisos para ver este listado.',
          });
          setUsuarios([]);
          setCargando(false);
          return;
        }

        setUsuarios(filtrados);
      } else {
        throw new Error(data.message || "Error al obtener usuarios");
      }
    } catch (error) {
      console.error("Error al obtener usuarios:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudieron cargar los usuarios.',
      });
    } finally {
      setCargando(false);
    }
  };

  const obtenerOrganismos = async () => {
    try {
      const res = await fetch(`${API}/organismos`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (res.ok) {
        setOrganismos(data);
      }
    } catch (error) {
      console.error("Error al obtener organismos:", error);
    }
  };

  const handleChange = e => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      let nuevaLista = [...formData.organismosPermitidos];
      if (checked) {
        nuevaLista.push(value);
      } else {
        nuevaLista = nuevaLista.filter(id => id !== value);
      }
      setFormData({ ...formData, organismosPermitidos: nuevaLista });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const crearUsuario = async () => {
    const nuevoUsuario = { ...formData };

    // 🔐 Si no es Dios, forzamos a usar su organismo actual
    if (userRol !== "Dios") {
      nuevoUsuario.rol = "usuario";
      nuevoUsuario.organismosPermitidos = [idOrganismoActual];
    }

    try {
      const res = await fetch(`${API}/usuarios`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(nuevoUsuario)
      });

      const data = await res.json();

      if (res.ok) {
        Swal.fire({
          icon: "success",
          title: "Usuario creado correctamente",
        });
        toggleModal();
        obtenerUsuarios();
      } else {
        throw new Error(data.error || "Error al crear usuario");
      }
    } catch (error) {
      console.error("Error al crear usuario:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message,
      });
    }
  };


  const cambiarEstadoUsuario = async (id, estadoActual) => {
    try {
      const res = await fetch(`${API}/usuarios/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ estadoActivo: !estadoActual })
      });
  
      const data = await res.json();
  
      if (res.ok) {
        Swal.fire({
          icon: 'success',
          title: 'Estado actualizado',
          text: `El usuario fue ${!estadoActual ? 'activado' : 'desactivado'} correctamente.`,
        });
        obtenerUsuarios(); // Recargar listado
      } else {
        throw new Error(data.error || 'No se pudo cambiar el estado');
      }
    } catch (error) {
      console.error("Error al cambiar estado del usuario:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No se pudo cambiar el estado del usuario.',
      });
    }
  };
  

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
  <h2>Listado de Usuarios</h2>
  {(userRol === "Dios" || userRol === "admin") && (
    <Button color="primary" onClick={toggleModal}>Nuevo Usuario</Button>
  )}
</div>


      {cargando ? (
        <p>Cargando...</p>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Nombre</th>
                <th>Apellido</th>
                <th>Correo</th>
                <th>Rol</th>
                <th>Organismos Permitidos</th>
                <th>Estado</th>
                <th>Acciones</th>

              </tr>
            </thead>
            <tbody>
              {usuarios.map((user, index) => (
                <tr key={index}>
                  <td>{user.nombre}</td>
                  <td>{user.apellido}</td>
                  <td>{user.correo}</td>
                  <td>{user.rol}</td>
                  <td>
                    {(user.organismosPermitidos || []).map((org, i) => (
                      <div key={i}>{org.nombre || '-'}</div>
                    ))}
                  </td>
                  <td>{user.estadoActivo ? "Activo" : "Inactivo"}</td>
<td>
  <Button
    color={user.estadoActivo ? "danger" : "success"}
    size="sm"
    onClick={() => cambiarEstadoUsuario(user._id, user.estadoActivo)}
  >
    {user.estadoActivo ? "Desactivar" : "Activar"}
  </Button>
</td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal */}
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Nuevo Usuario</ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col md={6}>
                <Label>Nombre</Label>
                <Input name="nombre" value={formData.nombre} onChange={handleChange} />
              </Col>
              <Col md={6}>
                <Label>Apellido</Label>
                <Input name="apellido" value={formData.apellido} onChange={handleChange} />
              </Col>
            </Row>
            <Label className="mt-3">Correo</Label>
            <Input name="correo" value={formData.correo} onChange={handleChange} />

            <Label className="mt-3">Contraseña</Label>
            <Input type="password" name="pass" value={formData.pass} onChange={handleChange} />

            {userRol === "Dios" && (
              <>
                <Label className="mt-3">Rol</Label>
                <Input type="select" name="rol" value={formData.rol} onChange={handleChange}>
                  <option value="usuario">Usuario</option>
                  <option value="admin">Admin</option>
                  <option value="socio">Socio</option>
                  <option value="Dios">Dios</option>
                </Input>

                <Label className="mt-3">Organismos Permitidos</Label>
                <div className="border rounded p-2" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                  {organismos.map((org) => (
                    <div key={org._id} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`org-${org._id}`}
                        name="organismosPermitidos"
                        value={org._id}
                        checked={formData.organismosPermitidos.includes(org._id)}
                        onChange={handleChange}
                      />
                      <label className="form-check-label" htmlFor={`org-${org._id}`}>
                        {org.nombre}
                      </label>
                    </div>
                  ))}
                </div>
              </>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={crearUsuario}>Guardar</Button>
          <Button color="secondary" onClick={toggleModal}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(ListadoUser);

